import { queryClient } from '@/lib/queryClient'

import { QueryKeys } from '@/enums'

export const getReactionIdsToRemove = (activitiesIdSet: Set<UUID>) => {
  const cachedReactionsQueriesData = queryClient.getQueriesData({
    queryKey: [QueryKeys.Reaction],
  })
  const reactionIdsToRemove = []

  cachedReactionsQueriesData.forEach((reactionQueryData) => {
    const reactionActivityId = reactionQueryData[0][1] as UUID

    if (!activitiesIdSet.has(reactionActivityId)) {
      reactionIdsToRemove.push(reactionActivityId)
    }
  })

  return reactionIdsToRemove
}
